import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDeleteMetricAssignmentMutation, useGetMetricAssignmentQuery, useCanAssignmentBeDeletedLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteMetricAssignment',
  props: {
    id: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useDeleteMetricAssig = useDeleteMetricAssignmentMutation(),
      deleteMetricAssignment = _useDeleteMetricAssig.mutate;
    var _useGetMetricAssignme = useGetMetricAssignmentQuery({
        id: props.id
      }),
      metricAssignmentResult = _useGetMetricAssignme.result;
    var assignment = computed(function () {
      var _metricAssignmentResu;
      return (_metricAssignmentResu = metricAssignmentResult.value) === null || _metricAssignmentResu === void 0 ? void 0 : _metricAssignmentResu.getMetricAssignment;
    });
    var assignmentMetricName = computed(function () {
      return assignment.value && assignment.value.metric && assignment.value.metric.name ? assignment.value.metric.name : '';
    });
    var assignmentMetricId = computed(function () {
      return assignment.value && assignment.value.metric && assignment.value.metric.id != null ? assignment.value.metric.id : '';
    });
    var assignmentAssigneeName = computed(function () {
      return assignment.value && assignment.value.assignee && assignment.value.assignee.name ? assignment.value.assignee.name : '';
    });
    var canBeDeleted = computed(function () {
      return !!(canAssignmentBeDeleted.value && canAssignmentBeDeleted.value.canBeDeleted);
    });
    var isDisabled = computed(function () {
      var _assignment$value, _assignment$value$met;
      return assignment !== null && assignment !== void 0 && (_assignment$value = assignment.value) !== null && _assignment$value !== void 0 && (_assignment$value$met = _assignment$value.metric) !== null && _assignment$value$met !== void 0 && _assignment$value$met.id ? [1216, 1217, 1218].includes(assignment.value.metric.id) : false;
    });
    var variables = computed(function () {
      return {
        id: props.id
      };
    });
    var _useCanAssignmentBeDe = useCanAssignmentBeDeletedLazyQuery(variables),
      loadCanAssignmentBeDeleted = _useCanAssignmentBeDe.load,
      loading = _useCanAssignmentBeDe.loading;
    var canAssignmentBeDeleted = ref(null);
    var handleClick = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isDisabled.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return loadCanAssignmentBeDeleted();
            case 4:
              result = _context.sent;
              if (result && _typeof(result) === 'object' && 'canAssignmentBeDeleted' in result) {
                canAssignmentBeDeleted.value = result.canAssignmentBeDeleted;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleClick() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      deleteMetricAssignment: deleteMetricAssignment,
      metricAssignmentResult: metricAssignmentResult,
      assignment: assignment,
      assignmentMetricName: assignmentMetricName,
      assignmentMetricId: assignmentMetricId,
      assignmentAssigneeName: assignmentAssigneeName,
      canBeDeleted: canBeDeleted,
      isDisabled: isDisabled,
      variables: variables,
      loadCanAssignmentBeDeleted: loadCanAssignmentBeDeleted,
      loading: loading,
      canAssignmentBeDeleted: canAssignmentBeDeleted,
      handleClick: handleClick
    };
  }
});